import { render, staticRenderFns } from "./LearnBannerDetail.vue?vue&type=template&id=d53da912&scoped=true&"
import script from "./LearnBannerDetail.vue?vue&type=script&lang=js&"
export * from "./LearnBannerDetail.vue?vue&type=script&lang=js&"
import style0 from "./LearnBannerDetail.vue?vue&type=style&index=0&id=d53da912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d53da912",
  null
  
)

export default component.exports